<template>
    <div class="basic_wrap">
        <van-nav-bar
                safe-area-inset-top
                fixed
                :title="$t('lang.新闻资讯')"
        />

        <div class="content">
            <NewsCard
                    style="margin-top: 15px"
                v-for="item in newsList"
                :key="item.id"
                :logo="item.img"
                :desc="item['title_'+lang]"
                @click="toDetail(item.id)"
            />
        </div>
    </div>
</template>

<script>
import NewsCard from '@/components/NewsCard/index.vue';
import Fetch from '@/utils/fetch';

export default {
    name: "news",
    components: {
        NewsCard
    },
    data() {
        return {
            lang: this.$i18n.locale || "en_us",
            newsList: [],
        }
    },
    created() {
        this.$parent.footer('news')
        this.getNews();
    },
    methods: {
        getNews() {
            Fetch('/index/getNews').then(res => {
                this.newsList = res.data.list
            })
        },
        toDetail(id){
            this.$router.push({
                path: '/newsDetail',
                query: {
                    id
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}

.basic_wrap {
  padding-top: 46px;
  display: flex;
  height: calc(100vh - 60px);
  box-sizing: border-box;
  flex-direction: column;
  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;

  .content {
    padding: 10px;
  }
}
</style>
